import React from "react";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-subtle py-12">
      <div className="container">
        <div className="grid-two-column">
          <div className="space-y-6">
            <div>
              <h3 className="heading-3 mb-2">Zachary Kalmbach</h3>
              <p className="body-regular text-sage">Private Chef & Culinary Consultant</p>
              <p className="body-small mt-4">
                Elevated dining experiences in the comfort of your home.
                Serving South East Florida: Broward, Miami-Dade, and Palm Beach Counties.
              </p>
            </div>
            
            <div className="flex items-center space-x-6">
              <a href="#" className="text-interactive-base hover:text-interactive-hover transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-interactive-base hover:text-interactive-hover transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          <div className="space-y-4">
            <h4 className="heading-3 mb-4">Contact Information</h4>
            <div className="flex items-center space-x-3">
              <Mail className="w-4 h-4 text-interactive-base" />
              <span className="body-regular">zacharyskalmbach@gmail.com</span>
            </div>
            <div className="flex items-center space-x-3">
              <Phone className="w-4 h-4 text-interactive-base" />
              <span className="body-regular">(561) 873-7499</span>
            </div>
            <div className="flex items-center space-x-3">
              <MapPin className="w-4 h-4 text-interactive-base" />
              <span className="body-regular">South East Florida</span>
            </div>
          </div>
        </div>
        
        <div className="border-t border-border-light mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="body-small text-secondary">
              © 2024 Zack Kalmbach Private Chef. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="body-small text-secondary hover:text-interactive-base transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="body-small text-secondary hover:text-interactive-base transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;